
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/term",
      function () {
        return require("private-next-pages/landing/term.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/term"])
      });
    }
  